import React from "react"
import { IField, getRequiredError } from './FieldValidation'
import { FormItem } from './FormItem'

// declare global {
//     interface Window {
//         grecaptcha: any
//         grecaptchaOnLoad: { (): any }
//         grecaptchaCallbacks: { (): any } []
//     }
// }

if (!window.grecaptchaOnLoad) {
    window.grecaptchaOnLoad = function () {
        if (window.grecaptchaCallbacks) {
            for (var c of window.grecaptchaCallbacks) {
                c();
            }
        }
    }
}

if (!window.grecaptchaCallbacks) {
    window.grecaptchaCallbacks = [];
}

export interface CaptchaProps {
    id: string
    collapsed?: boolean
    onChange: { (value: string): any },
    value: string
}

export interface CaptchaState {
    errorText?: string
}

export class Captcha extends React.Component<CaptchaProps, CaptchaState> implements IField {
    recaptchaId: any

    constructor(props?: CaptchaProps, context?: any) {
        super(props, context);

        this.state = {
        };
        this.recaptchaId = null;
    }

    reset() {
        if (this.recaptchaId !== null) {
            window.grecaptcha.reset(this.recaptchaId);
        }
    }

    componentDidMount() {
        if (window.grecaptcha && window.grecaptcha.render) {
            this.init();
        }
        else {
            window.grecaptchaCallbacks.push(() => this.init());
        }
    }

    init() {
        this.recaptchaId = window.grecaptcha.render(this.props.id, {
            sitekey: '6LefUCkUAAAAAOHjT5uhqljF_LQoiZSmG4kWGCbR',
            callback: (response: string) => this.props.onChange && this.props.onChange(response)
        });
    }

    render() {
        return <FormItem
            inputId={this.props.id}
            label="Captcha"
            srOnlyLabel={true}
            required={true}
            errorMessage={this.state.errorText}
        >
            <div id={this.props.id} />
        </FormItem>
    }

    getValue(): string {
        return this.props.value;
    }

    hasValue(): boolean {
        let v = this.getValue();
        return (v && v.length > 0);
    }

    focus() {
    }

    getErrorText(): string {
        if (!this.hasValue()) {
            return getRequiredError({ label: 'Captcha' });
        }
        return null;
    }

    validate(callback: { (res: boolean): any }, focus?: boolean) {
        let errorTest = this.getErrorText();
        this.setError(errorTest, () => {
            if (errorTest) {
                if (focus === true) {
                    this.focus();
                }
            }
            callback && callback(errorTest ? false : true);
        })
    }

    setError(errorText?: string, callback?: { (): any }) {
        this.setState({ errorText }, callback);
    }
}